<!-- 仓库 -->
<template>
    <div>
        <el-table :data="addressList" size="mini" style="margin-top: 0px;">
            <el-table-column type="index" width="150"> </el-table-column>
            <el-table-column label="仓库编号" prop="code" width="200"></el-table-column>
            <el-table-column label="仓库名称" prop="name" width="200">
                <template slot-scope="scope">
                    <el-link type="primary" @click="getStore(scope.row)">{{scope.row.name}}</el-link>
                </template>
            </el-table-column>
            <el-table-column label="仓库地址" prop="address"></el-table-column>
            <el-table-column label="联系人" prop="contractMan"></el-table-column>
            <el-table-column label="电话" prop="phone"></el-table-column>
            <el-table-column label="邮箱" prop="email"></el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.isUse" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" 
                    :inactive-value="0" @change="changeIsuse(scope.row)"> </el-switch>
                </template>
            </el-table-column>
        </el-table>
        <!-- 仓库地址下仓库信息 -->
        <el-dialog title="仓库分区信息" :visible.sync="addressVisible" width="60%" :before-close="addressClose" v-dialogDrag
        :close-on-click-modal="false">
            <el-descriptions :column="2" >
                <el-descriptions-item label="仓库编号">{{ addressDetail.code }}</el-descriptions-item>
                <el-descriptions-item label="仓库名称">{{ addressDetail.name }}</el-descriptions-item>
                <el-descriptions-item label="仓库地址">{{ addressDetail.address }}</el-descriptions-item>
            </el-descriptions>
            <el-button size="mini" type="primary" @click="addstore">新增</el-button>
            <el-table :data="storeList" max-height="400px">
                <el-table-column type="index" width="150"> </el-table-column>
                <el-table-column label="仓库分区名称" prop="name" ></el-table-column>
                <el-table-column label="仓库容量" prop="area" ></el-table-column>
                <el-table-column label="保税属性" prop="bondedProperty" ></el-table-column>
                <el-table-column label="管理属性" prop="manageProperty" ></el-table-column>
                <el-table-column label="" prop="" >
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="getLocation(scope.row)">查看库位</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog title="新增仓库分区" :visible.sync="storeVisible" width="30%" :before-close="storeClose" v-dialogDrag
        :close-on-click-modal="false">
            <el-form ref="storeForm" :model="storeForm" label-width="120px" size="mini" :rules="rules">
                <el-form-item label="仓库分区名称" prop="name">
                    <el-input v-model="storeForm.name"></el-input>
                </el-form-item>
                <el-form-item label="仓库容量" prop="area">
                    <el-input v-model="storeForm.area"></el-input>
                </el-form-item>
                <el-form-item label="保税属性" prop="bondedProperty">
                    <el-select v-model="storeForm.bondedProperty" placeholder="请选择保税属性" style="width: 100%;">
                        <el-option v-for="item in bondedPropertyList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="管理属性" prop="manageProperty">
                    <el-select v-model="storeForm.manageProperty" placeholder="请选择管理属性" style="width: 100%;">
                        <el-option v-for="item in managePropertyList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="saveAddStore('storeForm')">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :title=" storeDetail.name + ' 库位信息'" :visible.sync="locationVisible" width="60%" :before-close="locationClose" v-dialogDrag
        :close-on-click-modal="false">
            <el-button size="mini" type="primary" @click="addLocation">新增</el-button>
            <el-table :data="locationList">
                <el-table-column type="index" width="150"> </el-table-column>
                <el-table-column label="库位名称" prop="locationName" width="200"></el-table-column>
                <el-table-column label="库位容量" prop="capacity" ></el-table-column>
                <el-table-column label="库位类型" prop="locationType" ></el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog title="新增库位" :visible.sync="addLocationVisible" width="30%" :before-close="addLocationClose" v-dialogDrag
        :close-on-click-modal="false">
            <el-form ref="addLocationForm" :model="addLocationForm" label-width="80px" size="mini" :rules="locationRules">
                <el-form-item label="库位名称" prop="locationName">
                    <el-input v-model="addLocationForm.locationName"></el-input>
                </el-form-item>
                <el-form-item label="仓库容量" prop="capacity">
                    <el-input v-model="addLocationForm.capacity" onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')"></el-input>
                </el-form-item>
                <el-form-item label="库位类型" prop="locationType">
                    <el-select v-model="addLocationForm.locationType" placeholder="请选择库位类型" style="width: 100%;">
                        <el-option v-for="item in locationTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="saveAddLocation('addLocationForm')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 库位显示图 -->
         <!-- <wmsLocation></wmsLocation> -->
    </div>
</template>
<script>
import wmsLocation from '../../../components/wms/wmsLocation.vue'
export default {
    name: 'warehouse',
    components:{
        wmsLocation
    },
    //组件创建
    created() {
        this.getInfo()
        this.getLocationType()
        this.getbondedPropertyList()
        this.getmanagePropertyList()
    },
    data() {
        return {
            addressList: [],
            // 查看仓库时地址信息
            addressDetail:{},
            // 仓库列表
            storeList: [],
            // 仓库弹出框
            addressVisible:false,
            // 新增仓库弹出框
            storeVisible:false,
            // 新增仓库信息
            storeForm:{
                name:'',
                area:'',
                bondedProperty:'',
                manageProperty:'',
            },
            // 查看库位时仓库信息
            storeDetail:{},
            locationVisible:false, // 库位弹出框
            locationList:[],// 库位列表
            addLocationVisible:false,// 新增库位弹出框
            addLocationForm:{
                locationName:'',
                capacity:'',
                locationType:'',
                storeId:'',
            },
            locationTypeList:[], // 库位类型列表
            bondedPropertyList:[], // 保税属性列表
            managePropertyList:[], // 管理属性列表
            rules:{
                name:[
                    { required: true, message: '请输入仓库名称', trigger: 'blur' },
                ],
                area:[
                    { required: true, message: '请输入仓库容量', trigger: 'blur' },
                ],
                bondedProperty:[
                    { required: true, message: '请选择报税属性', trigger: 'change' },
                ],
                manageProperty:[
                    { required: true, message: '请选择管理属性', trigger: 'change' },
                ],
            },
            locationRules:{
                locationName:[
                    { required: true, message: '请输入库位名称', trigger: 'blur' },
                ],
                capacity:[
                    { required: true, message: '请输入库位容量', trigger: 'blur' },
                ],
                locationType:[
                    { required: true, message: '请选择库位类型', trigger: 'change' },
                ],
            }
        }
    },
    methods: {
        getInfo(){
            this.$api.getInfo(  ).then(res =>{
               this.addressList = res
            })
        },
        changeIsuse(data){
            console.log(data)
        },
        getStore(data){
            this.$api.getStore( data.name ).then(res =>{
                this.storeList = res
                this.addressDetail = data
                this.addressVisible = true
            })  
        },
        addressClose(){
            this.addressDetail = {}
            this.addressVisible = false
        },
        addstore(){
            this.storeVisible = true
        },
        saveAddStore(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const params = {
                        name: this.storeForm.name,
                        area: this.storeForm.area,
                        parentName: this.addressDetail.name,
                        bondedProperty: this.storeForm.bondedProperty,
                        manageProperty: this.storeForm.manageProperty,
                        
                    }
                    console.log(params);
                    this.$api.insStore( params ).then(res =>{
                        this.storeClose()
                        this.$api.getStore( this.addressDetail.name ).then(res =>{
                            this.storeList = res
                        })
                    })  
                    
                } else {
                    return false;
                }
            });
        },
        storeClose(){
            this.storeVisible = false
            this.storeForm = {
                name: '',
                area: '',
            }
        },
        // 查看库位
        getLocation(data){
            this.storeDetail = data
            this.$api.getLocation( data.id ).then(res =>{
                this.locationVisible = true
                this.locationList = res
            })
        },
        // 库位关闭
        locationClose(){
            this.locationVisible = false
            this.locationList = []
        },
        // 新增库位
        addLocation(){
            this.addLocationVisible = true 
        }, 
        // 获取库位类型
        getLocationType(){
            this.$api.getDicList( { value:'Wms库位类型'} ).then(res =>{
                this.locationTypeList = res
            })
        },
        // 获取管理属性
        getmanagePropertyList(){
            this.$api.getDicList( { value:'Wms管理属性'} ).then(res =>{
                this.managePropertyList = res
            })
        },
        // 获取保税属性
        getbondedPropertyList(){
            this.$api.getDicList( { value:'Wms保税属性'} ).then(res =>{
                this.bondedPropertyList = res
            })
        },
        // 保存新增库位
        saveAddLocation(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const params = {
                        locationName: this.addLocationForm.locationName,
                        capacity: this.addLocationForm.capacity,
                        locationType: this.addLocationForm.locationType,
                        storeId: this.storeDetail.id
                    }
                    this.$api.insLocation( params ).then(res =>{
                        this.$api.getLocation( params.storeId ).then(res =>{
                            this.locationList = res
                            this.$message({
                                message: '添加库位成功',
                                type: 'success'
                            });
                            this.addLocationClose()
                        })
                    })
                }
            })
        },
        // 关闭新增库位
        addLocationClose(){
            this.addLocationVisible = false
            this.$nextTick(()=>{
                this.$refs.addLocationForm.resetFields();
            })
            this.addLocationForm = {
                locationName:'',
                capacity:'',
                locationType:'',
                storeId:'',
            }
        },
    }
}
</script>
<style lang="css">

</style>